import styled from '@emotion/styled';
import { breakpoints } from '@nike/nike-design-tokens';
import { ProductCard } from '@nike/nike-design-system-components';
import { mobileOnly } from '../../utils/sharedStyles';

const { podiumCdsBreakpointS } = breakpoints;

export const StyledProductCard = styled(ProductCard)``;

export const StyledList = styled.ul`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: var(--podium-cds-size-spacing-grid-gutter-l);

  @media (max-width: ${podiumCdsBreakpointS}) {
    padding-bottom: 20vh;
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: ${podiumCdsBreakpointS}) and (${mobileOnly}) {
    padding-bottom: 20vh;
    grid-template-columns: repeat(3, 1fr);
  }
`;
